function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { getParentValues, getItemByValue, getParentLabels, isEqual } from "@yk-component/yk-util";
import { InputSearch } from "@yk-component/yk-input";
import Option from "./Option";
import "./options.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Options = function Options(props) {
  var value = props.value,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    className = props.className,
    onChange = props.onChange,
    header = props.header,
    footer = props.footer,
    wrapHeader = props.wrapHeader,
    wrapFooter = props.wrapFooter,
    clearText = props.clearText,
    visible = props.visible,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? "right" : _props$direction,
    disabled = props.disabled,
    readonly = props.readonly,
    hasSearch = props.hasSearch,
    onMouseEnterItem = props.onMouseEnterItem,
    prefixClass = props.prefixClass,
    nextIcon = props.nextIcon,
    isEqualFn = props.isEqualFn,
    renderEmpty = props.renderEmpty,
    searchOptions = props.searchOptions,
    onSearch = props.onSearch,
    searchData = props.searchData,
    loading = props.loading,
    renderLoading = props.renderLoading;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    levels = _useState2[0],
    setLevels = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    searchResult = _useState6[0],
    setSearchResult = _useState6[1];
  useEffect(function () {
    setLevels(!value ? [] : getParentValues(value, data, isEqualFn) || []);
  }, [visible]);
  useEffect(function () {
    if (!searchKey || searchData) return;
    var find = function find(key) {
      var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var items = [];
      var _iterator = _createForOfIteratorHelper(_options),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _item$children2;
          var _item = _step.value;
          if (_item.label.includes(key) && !(readonly !== null && readonly !== void 0 && readonly(_item) || _item.readonly)) {
            var _item$children;
            items.push(_item);
            ((_item$children = _item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) && items.push.apply(items, _toConsumableArray(_item.children));
            continue;
          }
          if ((_item$children2 = _item.children) !== null && _item$children2 !== void 0 && _item$children2.length) {
            var _items = find(key, _item.children);
            items.push.apply(items, _toConsumableArray(_items));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return items;
    };
    var _searchResult = find(searchKey, data);
    setSearchResult(_searchResult);
  }, [searchKey, data]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames("".concat(prefixClass, "Select"), className),
    children: [wrapHeader, hasSearch && /*#__PURE__*/_jsx(InputSearch, _objectSpread({
      value: searchKey,
      onChange: function onChange(ev) {
        setSearchKey(ev.value);
        onSearch === null || onSearch === void 0 ? void 0 : onSearch(ev.value);
      },
      wrapClassName: "".concat(prefixClass, "SelectSearch"),
      prefixClass: prefixClass
    }, typeof searchOptions === "function" ? searchOptions(searchKey, setSearchKey) : searchOptions)), loading ? (renderLoading === null || renderLoading === void 0 ? void 0 : renderLoading()) || "加载中……" : searchKey ? /*#__PURE__*/_jsx("div", {
      className: "".concat(prefixClass, "SelectSearchResult"),
      children: (searchData ? searchData(searchKey) : searchResult).length ? /*#__PURE__*/_jsx("nav", {
        children: (searchData ? searchData(searchKey) : searchResult).map(function (m) {
          var _getParentValues;
          var labels = getParentLabels(m.value, data, isEqualFn);
          return /*#__PURE__*/_jsx(Option, {
            prefixClass: prefixClass,
            active: isEqualFn(value, m.value) || ((_getParentValues = getParentValues(value, data, isEqualFn)) === null || _getParentValues === void 0 ? void 0 : _getParentValues.includes(m.value)),
            hover: levels.includes(m.value),
            disabled: (disabled === null || disabled === void 0 ? void 0 : disabled(m)) || m.disabled,
            readonly: (readonly === null || readonly === void 0 ? void 0 : readonly(m)) || m.readonly,
            onClick: function onClick(ev) {
              onChange === null || onChange === void 0 ? void 0 : onChange({
                value: m.value,
                option: m,
                event: ev
              });
            },
            children: "".concat(labels ? "".concat(labels.join("/"), "/") : "").concat(m.label)
          }, m.value);
        })
      }) : renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty()
    }) : /*#__PURE__*/_jsxs("div", {
      className: "".concat(prefixClass, "SelectOptionsWrap"),
      style: {
        flexDirection: direction === "right" ? "row" : "row-reverse"
      },
      children: [/*#__PURE__*/_jsxs("nav", {
        className: classNames("".concat(prefixClass, "SelectOptions")),
        children: [header, clearText !== false ? /*#__PURE__*/_jsx(Option, {
          prefixClass: prefixClass,
          active: (value !== null && value !== void 0 ? value : undefined) === undefined,
          onClick: function onClick(ev) {
            return onChange === null || onChange === void 0 ? void 0 : onChange({
              value: undefined,
              event: ev
            });
          },
          onMouseEnter: function onMouseEnter() {
            return setLevels([]);
          },
          children: clearText || "不限"
        }) : null, data.map(function (item) {
          var _getParentValues2;
          return /*#__PURE__*/_jsxs(Option, {
            prefixClass: prefixClass,
            active: isEqualFn(value, item.value) || ((_getParentValues2 = getParentValues(value, data, isEqualFn)) === null || _getParentValues2 === void 0 ? void 0 : _getParentValues2.includes(item.value)),
            hover: levels.includes(item.value),
            disabled: (disabled === null || disabled === void 0 ? void 0 : disabled(item)) || item.disabled,
            readonly: (readonly === null || readonly === void 0 ? void 0 : readonly(item)) || item.readonly,
            onClick: function onClick(ev) {
              onChange === null || onChange === void 0 ? void 0 : onChange({
                value: item.value,
                option: item,
                event: ev
              });
            },
            onMouseEnter: function onMouseEnter() {
              onMouseEnterItem === null || onMouseEnterItem === void 0 ? void 0 : onMouseEnterItem({
                value: item
              });
              setLevels([item.value]);
            },
            children: [item.label, item.children && nextIcon]
          }, item.value);
        }), footer]
      }), !searchKey && levels.map(function (level, index) {
        var _getItemByValue;
        var o = (_getItemByValue = getItemByValue(level, data, isEqualFn)) === null || _getItemByValue === void 0 ? void 0 : _getItemByValue.children;
        if (!o) return null;
        return /*#__PURE__*/_jsx("nav", {
          className: "".concat(prefixClass, "SelectOptions"),
          children: o.map(function (item) {
            var _getParentValues3;
            return /*#__PURE__*/_jsxs(Option, {
              prefixClass: prefixClass,
              active: isEqualFn(value, item.value) || ((_getParentValues3 = getParentValues(value, data, isEqualFn)) === null || _getParentValues3 === void 0 ? void 0 : _getParentValues3.includes(item.value)),
              hover: levels.includes(item.value),
              disabled: (disabled === null || disabled === void 0 ? void 0 : disabled(item)) || item.disabled,
              readonly: (readonly === null || readonly === void 0 ? void 0 : readonly(item)) || item.readonly,
              onClick: function onClick(ev) {
                return onChange === null || onChange === void 0 ? void 0 : onChange({
                  value: item.value,
                  option: item,
                  event: ev
                });
              },
              onMouseEnter: function onMouseEnter() {
                onMouseEnterItem === null || onMouseEnterItem === void 0 ? void 0 : onMouseEnterItem({
                  value: item
                });
                setLevels(function (pre) {
                  return [].concat(_toConsumableArray(pre.slice(0, index + 1)), [item.value]);
                });
              },
              children: [item.label, item.children && nextIcon]
            }, item.value);
          })
        }, index);
      })]
    }), wrapFooter]
  });
};
Options.defaultProps = {
  prefixClass: "yk",
  isEqualFn: isEqual
};
export default Options;